import DataGrid from "@shared/DataGrid";
import React from "react";
import { Modal } from "semantic-ui-react";

const KioskModal = (props) => {
  const { open, onClose, details } = props;
  return (
    <Modal closeIcon open={open} size="mini" onClose={onClose}>
      <Modal.Header>{details.title ?? "Details"}</Modal.Header>
      <Modal.Content>
        <DataGrid
          headings={details.grid.headerDef}
          data={details.grid.data}
          rowDef={details.grid.rowDef}
          hideOverflow
        />
      </Modal.Content>
    </Modal>
  );
};

export default KioskModal;
